<template>
  <b-form-group :label-for="labelFor">
    <template v-if="label" #label>
      {{ label }}
      <b-icon
        v-if="info"
        v-b-popover.hover.top="info"
        class="ml-2 delete-question-icon"
        icon="question-circle"
      />
      <span v-if="required" class="red-text">*</span>
      <p v-if="showDescription" class="text-muted small mb-0 mt-0">
        <slot v-if="$slots.description" name="description"></slot>
        <template v-else>
          {{ description }}
        </template>
      </p>
    </template>
    <slot />
  </b-form-group>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },

    labelFor: {
      type: String,
      default: "",
    },

    description: {
      type: String,
      default: "",
    },

    required: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: "",
    },
  },
  computed: {
    showDescription() {
      return this.$slots.description || this.description;
    },
  },
};
</script>
